import { z } from "zod";

export const contactSchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name must be less than 100 characters"),
  
  email: z
    .string()
    .trim()
    .email("Please enter a valid email address")
    .max(255, "Email must be less than 255 characters"),
  
  userType: z
    .string()
    .refine((val) => ["job-seeker", "employer", "partner", "other"].includes(val), {
      message: "Please select a valid user type"
    }),
  
  message: z
    .string()
    .trim()
    .min(10, "Message must be at least 10 characters")
    .max(2000, "Message must be less than 2000 characters")
});

export type ContactFormData = z.infer<typeof contactSchema>;